import { useGlobalLoading as useGlobalLoadingContext } from '../contexts/GlobalLoadingContext';
import { useCallback } from 'react';

export const useGlobalLoading = () => {
  const context = useGlobalLoadingContext();
  
  if (!context) {
    throw new Error('useGlobalLoading must be used within a GlobalLoadingProvider');
  }
  
  const { startLoading, stopLoading, setLoading, isLoading, loadingMessage } = context;

  // Wrapper for async functions that automatically manages loading state
  const withLoading = useCallback(async (asyncFunction, message = 'Loading...') => {
    if (!startLoading || !stopLoading) {
      console.warn('Global loading functions not available, executing without loading state');
      return await asyncFunction();
    }
    
    startLoading(message);
    try {
      const result = await asyncFunction();
      return result;
    } finally {
      stopLoading();
    }
  }, [startLoading, stopLoading]);

  // Wrapper for API calls with automatic loading management
  const apiCall = useCallback(async (apiFunction, message = 'Loading...') => {
    return withLoading(apiFunction, message);
  }, [withLoading]);

  return {
    isLoading,
    loadingMessage,
    startLoading,
    stopLoading,
    setLoading,
    withLoading,
    apiCall
  };
};
